import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaSignInAlt, FaUserPlus } from "react-icons/fa";
import "./Welcome.css";

export default function Welcome() {
  const navigate = useNavigate();

  useEffect(() => {
    // Vérification de la connexion : Redirection si un token est trouvé
    const token = localStorage.getItem("token");
    if (token && token.trim() !== "") {
      navigate("/home"); 
    }
  }, [navigate]);

  return (
    <div className="welcome-container">
      <div className="welcome-card">
        
        {/* ✅ CORRECTION POUR LOGO DANS LE DOSSIER PUBLIC :
          Utilisation du chemin absolu /MaBoutik.png
        */}
        <img src="/MaBoutik.png" alt="MaBoutik Logo" className="app-logo" />

        <h1 className="app-title">Bienvenue sur MaBoutik!</h1>
        
        <p className="app-description">
          L'outil **indispensable** pour votre commerce. Gérez vos{" "}
          <strong className="accent-text">ventes</strong>, suivez vos{" "}
          <strong className="accent-text">dépenses</strong> et optimisez votre{" "}
          <strong className="accent-text">gestion de stock</strong> en toute simplicité.
        </p>

        <div className="button-group">
          <button className="btn login-btn" onClick={() => navigate("/login")}>
            <FaSignInAlt /> Me connecter
          </button>
          <button className="btn register-btn" onClick={() => navigate("/register")}>
            <FaUserPlus /> Créer mon compte
          </button>
        </div>

        <div className="footer">
          <p>© 2025 **MaBoutik** • Votre allié commercial.</p>
        </div>
      </div>
    </div>
  );
}